export default __webpack_public_path__ + "static/media/Quantico-BoldItalic.ef3d9237.ttf";